import React from 'react';

function IntroScreen({ envelopeOpening, onEnvelopeClick }) {
    return (
        <div className="App intro-screen">
            <div className={`envelope-container ${envelopeOpening ? 'opening' : ''}`} onClick={onEnvelopeClick}>
                <div className="envelope">
                    <div className="envelope-body"></div>
                    <div className="envelope-flap">
                        <div className="envelope-heading">
                            <span className="envelope-name">Gianluca</span>
                            <span className="envelope-age">30</span>
                        </div>
                    </div>
                    <div className="envelope-seal">
                        <img src="/seal-image.png" alt="Sigillo GR" className="seal-image" />
                    </div>
                </div>
                <div className="invitation-preview">
                    <h1 className="elegant-title">Hai Ricevuto un invito!</h1>
                    <p className="preview-text">da Gianluca Rainò</p>
                </div>
                {!envelopeOpening && (
                    <p className="click-hint">Clicca per aprire</p>
                )}
            </div>
        </div>
    );
}

export default IntroScreen;
